import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useMemo } from "react"
import React from "react"
import { useOperationInfoCtx } from "./context"
import {
    PhotoTour,
    PhotoTourItem,
    PhotoTourItemSampleImage,
    usePhotoTourByCleaningId
} from "@/hooks/usePhotoTour"

export interface OperationPhotoTourContextState {
    tour?: PhotoTour
    items?: PhotoTourItem[]
    sampleImagesMap?: Record<string, PhotoTourItemSampleImage[]>
}

const OperationPhotoTourContext = React.createContext<
    OperationPhotoTourContextState | undefined
>(undefined)

export const OperationPhotoTourProvider = ({
    children
}: React.PropsWithChildren) => {
    const { token } = useAuth()
    const { operationId } = useOperationInfoCtx()
    const { data } = usePhotoTourByCleaningId(token, operationId)

    const value = useMemo(
        () => ({
            tour: data?.photoTour,
            items: data?.items,
            sampleImagesMap: data?.sampleImagesMap
        }),
        [data?.items, data?.photoTour, data?.sampleImagesMap]
    )

    return (
        <OperationPhotoTourContext.Provider value={value}>
            {children}
        </OperationPhotoTourContext.Provider>
    )
}

export const useOperationPhotoTourContext = () => {
    const ctx = React.useContext(OperationPhotoTourContext)
    if (!ctx) {
        throw new Error(
            "useOperationPhotoTourContext must be used within a OperationPhotoTourProvider"
        )
    }

    return ctx
}
